import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import * as React from "react";
import useNavigation from "./useNavigation";
/**
 * Hook to get a value from the current navigation state using a selector.
 *
 * @param selector Selector function to get a value from the state.
 */ export default function useNavigationState(selector) {
    var navigation = useNavigation();
    // We don't care about the state value, we run the selector again at the end
    // The state is only to make sure that there's a re-render when we have a new value
    var _React_useState = _sliced_to_array(React.useState(function() {
        return selector(navigation.getState());
    }), 2), setResult = _React_useState[1];
    // We store the selector in a ref to avoid re-subscribing listeners every render
    var selectorRef = React.useRef(selector);
    React.useEffect(function() {
        selectorRef.current = selector;
    });
    React.useEffect(function() {
        var unsubscribe = navigation.addListener("state", function(e) {
            setResult(selectorRef.current(e.data.state));
        });
        return unsubscribe;
    }, [
        navigation
    ]);
    return selector(navigation.getState());
}
